import React from 'react'

interface WorkPanelWrapperProps {
  title: string
  children: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

const WorkPanelWrapper: React.FC<WorkPanelWrapperProps> = ({
  title,
  children,
  actions,
  className = ''
}) => {
  return (
    <div className="h-full flex flex-col">
      <div className="bg-white border-b border-gray-200">
        <div className="flex items-center justify-between px-6 py-4">
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          {actions && (
            <div className="flex items-center space-x-2">
              {actions}
            </div>
          )}
        </div>
      </div>
      <div className={`flex-1 overflow-auto bg-gray-50 p-6 ${className}`}>
        {children}
      </div>
    </div>
  )
}

export default WorkPanelWrapper
